// @ts-ignore
import { getDeviceID } from '../analytics/handlers/amplitude/fixDeviceID.web';
import { executeAfterLoad } from '../app/functions.web';
import { getLogger } from '../base/logging/functions';
const logger = getLogger('features/deep-linking');
const DEEPLINK = 'deeplink';
const HEALTH = 'health';
const ports = [
    { port: 59202, type: HEALTH },
    { port: 59201, type: DEEPLINK },
    { port: 8431, type: HEALTH },
    { port: 8430, type: DEEPLINK }
];
function tryHealthPort(port, state) {
    return new Promise((resolve, reject) => {
        const img = document.createElement('img');
        const room = window.location.pathname;
        const segments = room.slice(1).split('/'); // Remove leading slash before splitting
        const [tenant, roomName] = segments.length > 1 ? segments : ['', segments[0]];
        const timeoutId = setTimeout(() => {
            img.src = ''; // Stop the request
            img.remove(); // Clean up
            reject(new Error(`Health port ${port} timeout after 1000ms`));
        }, 1000);
        img.onload = () => {
            clearTimeout(timeoutId);
            let url = `vo://jitsimeetings${generateParams(state)}&roomName=${roomName}`;
            if (tenant) {
                url += `&tenant=${tenant}`;
            }
            // This is needed to workaround https://issues.chromium.org/issues/41398687
            executeAfterLoad(() => {
                window.open(url, '_self');
            });
            resolve(null);
        };
        img.onerror = (err) => {
            clearTimeout(timeoutId);
            reject(err);
        };
        const url = `http://localhost:${port}/health${generateParams(state)}`;
        img.src = url;
    });
}
/**
 * Tries to load an image from a local server.
 * This approach is widely used to bypass CORS retrictions and avoid
 * deploying a https server on the client side which would also imply
 * storing SSL certificates on that client.
 *
 * @param {number} port - The port on which we try to reach the server.
 * @param {Object} state - Object containing current redux state.
 * @returns {Promise<void>}
 */
function tryPort(port, state) {
    return new Promise((resolve, reject) => {
        const img = document.createElement('img');
        const roomName = window.location.pathname;
        const timeoutId = setTimeout(() => {
            img.src = ''; // Stop the request
            img.remove(); // Clean up
            reject(new Error(`Deeplink port ${port} timeout after 1000ms`));
        }, 1000);
        img.onload = () => {
            clearTimeout(timeoutId);
            resolve(null);
        };
        img.onerror = (err) => {
            clearTimeout(timeoutId);
            reject(err);
        };
        const url = `http://localhost:${port}${roomName}${generateParams(state)}`;
        img.src = url;
    });
}
/**
 * Generates search params to be passed to the deep linking VOD URL.
 *
 * @param {Object} state - Object containing current redux state.
 * @returns {string} - String with the params.
 */
function generateParams(state) {
    const { locationURL } = state['features/base/connection'];
    const { hash, search } = locationURL || {};
    // The device ID will always be available in local storage after the Amplitude initialization executes.
    const deviceId = getDeviceID();
    return `${search ? `${search}&` : '?'}ts=${Date.now()}${deviceId ? `&__AMDID=${deviceId}` : ''}${hash ? `&${hash.substring(1)}` : ''}`;
}
/**
 * Opens Electron (desktop) container app.
 *
 * @param {Object} state - Object containing current redux state.
 * @returns {Promise<boolean>} - Resolves with true if the attempt to open the Electron container app was successful
 * and resolves with false otherwise.
 */
export async function _openDesktopApp(state) {
    const userAgent = navigator.userAgent.toLowerCase();
    const isRunningInElectron = userAgent.indexOf('8x8work') > -1 || userAgent.indexOf('electron') > -1;
    if (isRunningInElectron) {
        logger.info('Trying to deeplink prevented due to running in Electron');
        return false;
    }
    for (const { port, type } of ports) {
        try {
            if (type === HEALTH) {
                await tryHealthPort(port, state);
            }
            else {
                await tryPort(port, state);
            }
            logger.info(`Trying ${type} endpoint succeeded`, port);
            return true;
        }
        catch (err) {
            logger.error(`Trying ${type} endpoint failed`, err);
        }
    }
    return false;
}
